import { TabTitle } from "../utils/helperFunctions";

//Contact form , uses a emailer package to send emails - formsubmit
export default function Contact() {
  TabTitle("Contact");
  return (
    <div
      className="ui"
      style={{
        backgroundColor: "black",
        height: window.innerHeight,
      }}
    >
      <div
        className="ui center aligned grid padded"
      >
        <div className="ui column content centered"     id="contactPage" >
          <form
            action="https://formsubmit.co/mawwebservicesllc@gmail.com"
            method="POST"
            className="ui form small text container"
          >
            <div className="ui centered center aligned inverted">
              <span
                className="ui text huge"
                style={{
                  textAlign: "center",
                  color: "gold",
                  fontWeight: "bold",
                }}
              >
                Contact
              </span>
              <br></br>
              <br></br>
              <p>
                <span
                  className="ui text white"
                  style={{
                    color: "white",
                    textShadow: ".25px .25px white",
                    fontSize: "1.2rem",
                  }}
                >
                  Do you need help starting up a project or help with an
                  existing one? Feel free to reach out to me with any questions
                  using the form below!
                </span>
              </p>
            </div>
            <br></br>
            <br></br>
            {/* Captcha hidden fields */}
            <input type="hidden" name="_subject" value="Email from portfolio" />
            <input
              type="hidden"
              name="_next"
              value="http://mawwebservices.netlify.app/thanks"
            />
            <input type="hidden" name="_captcha" value="false" />
            <div className="field">
              <input
                id="name"
                type="text"
                required
                name="name"
                placeholder="Full Name"
              />
            </div>
            <br></br>
            <div className="field">
              <input
                id="email"
                type="text"
                required
                name="email"
                placeholder="Preferred Email Address"
              />
            </div>
            <br></br>
            <div className="field">
              <select
                type="text"
                name="category"
                id="category"
                className="ui fluid dropdown"
              >
                <option selected disabled>
                  Subject
                </option>
                <option style={{ color: "silver" }}>General</option>
                <option style={{ color: "silver" }}>WebSite Design</option>
                <option style={{ color: "silver" }}>Start Up</option>
                <option style={{ color: "silver" }}>Misc Services</option>
              </select>
            </div>
            <br></br>

            <div className="field">
              <textarea
                id="message"
                required
                type="text"
                name="message"
                rows="4"
                placeholder="Please leave your message here...."
              />
            </div>

            <div className="ui row" style={{ textAlign: "center" }}>
              <button
                id="submit"
                className="ui button inverted basic learnMore teal circular"
                style={{ marginTop: "2rem" }}
              >
                <a id="submitText" href="thanks">
                  Submit Form
                </a>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
